import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { BRANDING } from "../config/branding";

const AppFooter = () => (
  <Box
    component="footer"
    sx={{
      backgroundColor: 'background.paper',
      borderTop: 1,
      borderColor: 'divider',
      py: 3,
      mt: 'auto'
    }}
  >
    <Container maxWidth="lg">
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
      >
        {BRANDING.copyright}
      </Typography>
    </Container>
  </Box>
);

export default AppFooter;
